import { CRUDUser } from './CRUDUser'
import CRUDUserContextProvider from './Provider/CRUDUserProvider'
import CRUDUserPopupProvider from './Provider/CRUDUserPopupProvider'

export const CRUDUserPage = () => (
  <CRUDUserPopupProvider>
    <CRUDUserContextProvider>
      <CRUDUser />
    </CRUDUserContextProvider>
  </CRUDUserPopupProvider>
)
